import { render, staticRenderFns } from "./NsPopup.vue?vue&type=template&id=5db47956&scoped=true&"
import script from "./NsPopup.vue?vue&type=script&lang=js&"
export * from "./NsPopup.vue?vue&type=script&lang=js&"
import style0 from "./NsPopup.vue?vue&type=style&index=0&id=5db47956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db47956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db47956')) {
      api.createRecord('5db47956', component.options)
    } else {
      api.reload('5db47956', component.options)
    }
    module.hot.accept("./NsPopup.vue?vue&type=template&id=5db47956&scoped=true&", function () {
      api.rerender('5db47956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsPopup.vue"
export default component.exports